import { getString, parseURL } from '@archipro-website/top-navigation';
import type {
    FilterSortOption,
    SearchServiceFilters,
    SearchServiceSortOption,
} from '../type/api';
import { FILTER_SORT_OPTION_SCHEMA } from '../type/api';

/**
 * Check if a string is a valid sort option and return it it is, else return null.
 * @param sortValue The sort option to validate.
 * @returns The sort option if it is valid, else null.
 */
export function validateSort(sortValue?: string): FilterSortOption {
    if (!sortValue) {
        return null;
    }
    const result = FILTER_SORT_OPTION_SCHEMA.safeParse(sortValue);
    if (result.success) {
        return result.data;
    }
    return null;
}

/**
 * Get the sort value from the URL and transform it into a valid sort option
 * for the Search Service and apply filters depending on the sort option.
 * @param url The URL to get the sort value from.
 * @param filters The filters to apply for the Search Service query.
 * @param defaultSort The sort value to use if not found in the URL.
 * @returns The sort option for the Search Service.
 */
export function applyESSearchSort(
    url: string,
    filters: SearchServiceFilters,
    defaultSort?: FilterSortOption,
): SearchServiceSortOption {
    const { params } = parseURL(url);
    let sort = validateSort(getString(params, 'sort')) ?? defaultSort;
    if (sort === 'uncategorised') {
        sort = null;
        filters.noCategory = true;
    } else if (sort === 'invalidLink') {
        sort = null;
        filters.invalidLink = true;
    }
    return sort ?? null;
}
